"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Order = require("./Order");
Object.keys(_Order).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Order[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Order[key];
    }
  });
});